<i18n>
{
    "en": {},
    "ru": {}
}
</i18n>
<template>
    <div class="page-legal">
        <div class="page-legal__block">
            <PageBlock>
                <Breadcrumb
                    :items="breadcrumbs"/>
                <PageBlock
                    :big-title="!isDeviceDesktop"
                    :title="pageName"
                    small-header
                    content-padding
                    content-visible
                    class="page-legal__content"
                    :heading-tag="'h1'">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <div class="html-content" v-html="pageDescription"></div>
                </PageBlock>
            </PageBlock>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import get from "lodash/get";
import includes from 'lodash/includes'
import PageBlock from '@/components/layout/AppPageBlock'
import Breadcrumb from '@/components/layout/nav/Breadcrumb'

import LegalDocuments from '@/models/legal-documents'

export default {
    name: 'LegalPage',
    components: {
        Breadcrumb,
        PageBlock
    },
    async asyncData({app, params, error}) {

        let code = params.code

        if(code === 'cooperation-design-rules')
            code = 'ad-design-rules'

        if(code === 'cooperation-publications-rules')
            code = 'ad-publications-rules'

        try {
            const baseUrl = app.i18n.__baseUrl
            const document = await (new LegalDocuments)
                .find(code)
                .catch((e) => {
                    error({statusCode: e.response.status, message: e.response.data});
                });
            const pageName = get(document, 'name', '')
            const pageDescription = get(document, 'description', '')

            const breadcrumbs = [
                {
                    path: baseUrl,
                    name: app.i18n.t('breadcrumbs.home_page'),
                },
            ];

            if (includes(['cooperation-design-rules', 'cooperation-publications-rules'], params.code)) {
                breadcrumbs.push({
                    path: baseUrl + '/cooperation',
                    name: app.i18n.t('breadcrumbs.cooperation'),
                })
            }

            breadcrumbs.push({ name: pageName })

            return {
                breadcrumbs,
                document,
                pageName,
                pageDescription
            }

        } catch (e) {
            console.error(e);
        }
    },
    data() {
        return {
            loaded: false,
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop'])
    },
    mounted() {
        this.loaded = true;
    },
    methods: {
        get,
    },
    head(){
        return {
            title: this.$options.filters.metaSitenameTitle(this.pageName)
        }
    }
}
</script>

<style lang="less">
.page-legal {
    .breadcrumb {
        margin-bottom: rem(4);
    }

    &__content {
        p {
            line-height: rem(25.5);

            + strong {
                margin-top: rem(16);
            }
        }

        a {
            color: @color-violet;

            .hover({
                text-decoration: underline;
            });
        }

        strong,
        b {
            display: inline-block;

            font-size: rem(16);
            font-weight: 500;
            line-height: rem(24);
        }

        @{desktop} & {
            margin-right: auto;
            margin-left: auto;
            padding-top: rem(15);
            padding-bottom: rem(80);

            max-width: rem(700);

            .page-block__content {
                padding-top: rem(28);
            }
        }
    }
}
</style>
